import { useEffect } from 'react'
import { Toaster as Sonner, toast as showSonner } from 'sonner'
import { v4 as uuid } from 'uuid'
import { Toast } from './toast.server'

export function Toaster({ toast }: { toast?: Toast | null }) {
  return (
    <>
      <Sonner closeButton position="bottom-right" />
      {toast ? <ShowToast toast={toast} /> : null}
    </>
  )
}

export function showToast(toast: Omit<Toast, 'id'> & { id?: string }) {
  showSonner[toast.type](toast.title, { id: toast.id ?? uuid(), description: toast.description })
}

function ShowToast({ toast }: { toast: Toast }) {
  const { id, type, title, description } = toast
  useEffect(() => {
    setTimeout(() => {
      showToast({ id, description, title, type })
    }, 0)
  }, [description, id, title, type])
  return null
}
